export class Auditoria {
    NumeroTransaccion: string;
    NumeroDocumento: string;
    TipoOperacion: number;
    Mensaje: string;

    constructor(numeroTransccion: string, numeroDocumento: string, tipoOperacion: number, mensaje: object) {
        this.NumeroTransaccion = numeroTransccion;
        this.NumeroDocumento = numeroDocumento;
        this.TipoOperacion = tipoOperacion;
        this.Mensaje = JSON.stringify(mensaje);
    }
}
